import { Settings } from '@app/app.settings';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class CustomMultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private resources: { prefix: string; suffix: string }[]
  ) {}

  getTranslation(lang: string): Observable<object> {
    const locale = LocaleManager.getLocaleFromLangCode(lang);

    const requests = this.resources.map((resource) => this.http.get(`${resource.prefix}${locale}${resource.suffix}`));

    return forkJoin(requests).pipe(map((responses) => Object.assign({}, ...responses)));
  }
}

export class LocaleManager {
  private static langMap: { [key: string]: { [region: string]: string } } = {
    en: {
      GB: 'en_GB',
      default: 'en_GB',
    },
    es: { default: 'es_ES' },
    fr: { default: 'fr_FR' },
    de: { default: 'de_DE' },
    it: { default: 'it_IT' },
    pt: { default: 'pt_PT' },
  };

  static getLocaleFromLangCode(langCode: string, region?: string): string {
    const langLocales = this.langMap[langCode];

    if (langLocales) {
      return langLocales[region] || langLocales['default'];
    }

    return Settings.defaultLang;
  }
}
